(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('priceMode', function(broker, preferences, analytics) {
    let inst = 0;

    //we need to give each instance of the price mode directive a unique id so that each one can have its own broker
    //subscription
    function getInstance() {
        inst += 1;
        return inst;
    }

    return {
        restrict: 'E',
        replace: true,
        scope: {
            forcePriceMode: '=',
            ignorePreference: '=',
            isKidsFree: '=?'
        },
        templateUrl: 'partials/home/directivetemplate?type=PriceMode',
        link(scope) {
            const i = getInstance();
            let timeDirectiveRendered = new Date();

            scope.$watch('priceMode', function(v, o) {
                if (v == null || v === o) {
                    return;
                }
                broker.publish('priceModeChanged', scope.priceMode);
                preferences.set('priceMode', scope.priceMode);

                //Track in mixpannel.  Need to ignore the case when pricemode is being initalised or set in an ab-test.
                let timespan = new Date() - timeDirectiveRendered;
                if (timespan > 2000) {
                    analytics.track('mixpanel', 'PriceModeToggle', {
                        newValue: v === 0 ? 'perPerson' : 'totalPrice'
                    });
                }
            });

            if (scope.forcePriceMode !== undefined) {
                scope.priceMode = scope.forcePriceMode;
            }

            if (!scope.ignorePreference) {
                preferences.get('priceMode').then(function(p) {
                    scope.priceMode = p;
                });
            }

            broker.subscribe(`priceModeDirective${i}`, 'priceModeChanged', function(ev) {
                scope.priceMode = ev.data;  //because we may have more than one price mode directive on the screen and the must be in sync
            });

            scope.$on('$destroy', function() {
                broker.unsubscribe(`priceModeDirective${i}`, 'priceModeChanged');
            });
        }
    };
});
})();
